import { LEVEL_MAP } from 'apps/find-designers/consts';

interface User {
    userId: number;
    isIdentified: boolean;
    isClientOrCertifiedDesigner: boolean;
}

interface Designer {
    userId: number;
}

export const userCanFavourite = (user: User, designer: Designer): boolean => {
    return user.isIdentified && user.userId !== designer.userId && user.isClientOrCertifiedDesigner;
};

export const isContact = (flags: Array<String>): boolean => {
    return flags.includes('IS_FAVORITE') || flags.includes('HAS_WORKED_WITH');
};

export const getDesignerLevel = (level: string): string => {
    return LEVEL_MAP[level];
};



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/utils/designers.tsx